import { html } from 'lit';
import { createElement, FileX2 } from 'lucide';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-file-x')
export class PdsIconFileX extends PdsIcon {
  createIconElement(): SVGElement {
    return createElement(FileX2);
  }

  render() {
    return html`${this.icon}`;
  }
}
